import React from "react";

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

const Pricing = () => {
    return(
        <section id="pricing" class="pricing section-bg">
      <div class="container">

        <div class="section-title" data-aos="">
          <h2>Pricing</h2>
          <p>It's all about your value. We have made resonable price plan to fit your needs. </p>
        </div>

        <div class="row">

          <div class="col-lg-3 col-md-6">
            <div class="box" data-aos="">
            <span class="advanced">Trending</span>
              <h3>Silver</h3>
              <h4><sup>₹</sup>8999<span> /-</span></h4>
              <ul>
                <li>Upto 5 Static Pages</li>
                <li>Unique Domain Name</li>
                <li>Free 1 year Hosting</li>
                <li>1 Business Email (250 MB each)</li>
                <li class="na">24/7 Support</li>
                <li class="na">Payment Gateway Integration</li>
              </ul>
              <div class="btn-wrap">
                <a href="tel:+918806122020" class="btn-buy">Call Now</a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-4 mt-md-0">
            <div class="box featured" data-aos="" data-aos-delay="">
           
              <h3>Business</h3>
              <h4><sup>₹</sup>14999<span>/-</span></h4>
              <ul>
                <li>Upto 10 Pages</li>
                <li>1 Dynamic Page</li>
                <li>Unique Domain Name</li>
                <li>Free 1 year Hosting</li>
                <li>2 Business Email (250 MB each)</li>
                <li>1 Contact Page </li>
                <li class="na">24/7 Support</li>
                <li class="na">Payment Gateway Integration</li>
              </ul>
              <div class="btn-wrap">
              <a href="tel:+918806122020" class="btn-buy">Call Now</a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-4 mt-lg-0">
            <div class="box" data-aos="" data-aos-delay="">
              <h3>Golden</h3>
              <h4><sup>₹</sup>19999<span> /-</span></h4>
              <ul>
              <li>Upto 15 Static Pages</li>
                <li>5 Dynamic Pages</li>
                <li>Unique Domain Name</li>
                <li>Free SSL Certificate</li>
                <li>Free 1 year Hosting</li>
                <li>2 Business Email (250 MB each)</li>
                <li>2 GB Bandwidth </li>
                <li>Google Business Listing</li>
                <li>Live Chat</li>
                <li>24/7 Support</li>
                <li class="na">Payment Gateway Integration</li>
              </ul>
              <div class="btn-wrap">
              <a href="tel:+918806122020" class="btn-buy">Call Now</a>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-4 mt-lg-0">
            <div class="box" data-aos="" data-aos-delay="">
              <span class="advanced">Advanced</span>
              <h3>Ultimate E-Commerce </h3>
              <h4><sup>₹</sup>29999<span> /-</span></h4>
              <ul>
              <li>Upto 20 Pages</li>
                <li>1 Admin Page</li>
                <li>Unique Domain Name</li>
                <li>Free SSL Certificate</li>
                <li>Free 1 year Hosting</li>
                <li>5 Business Email (250 MB each)</li>
                <li>2 GB Bandwidth </li>
                <li>Google Business Listing</li>
                <li>Live Chat</li>
                <li>24/7 Support</li>
                <li>Payment Gateway Integration</li>
              </ul>
              <div class="btn-wrap">
              <a href="tel:+918806122020" class="btn-buy">Call Now</a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
    )
}

export default Pricing;